import styled from 'styled-components';
import media from 'src/styles/Media.styled';

export const ReportUsageButtonContainer = styled.div`
    display: flex;
    width: 100%;
    max-width: 1096px;
    flex-direction: row;
    justify-content: ${(props) =>
        props.justifyContent ? props.justifyContent : 'flex-end'};
    padding-right: 14px;

       //ipad Pro(10.5 inch) landscape
    @media screen and (min-device-width: 1100px) and (max-device-width: 1120px) and (min-device-height: 825px) and (max-device-height: 840px) and (orientation: landscape) {
        width: 100%;
        padding-right: 50px;
    }

    ${media.mediumDevice`
        padding-right: 30px;
    `}

    ${media.smalDevice`
        padding-right: 30px;
    `}

    ${media.mobileDevice`
        justify-content: space-evenly;
        padding-right: 0px;
    `}
    botton{
        @media only screen and (max-device-width: 360px) {
            font-size: 13px !important;
        }
    }
`;
export const PopupContainer = styled.div`
    color: #202124;
    float: left;
    width: 340px;
    height: 286px;
    font-family: 'AvenirNextWorld Demi';
    font-size: 14px;
    border: none;
    border-radius: 0;
    overflow-x: hidden;
    overflow-y: auto;
`;

export const PopUpFooter = styled.div`
    display:flex;
    justify-content : flex-end;
    ${media.mobileDevice`
    margin-top:21px;    
    `}
    ${media.smalDevice`
    margin-top:21px;    
    `}
`;
export const Buttons = styled.button`
border-radius: 25px;
width: 140px;
height: 38px;
padding: 5px;
background: white;
margin-right : 11px;
cursor:pointer;
border : 1px solid #140F4B;
font-family: AvenirNextWorld Demi;
`;
